/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ valueText: NonNullable<unknown> }} Profile_Editors_Weight_SavedInputs */

const en_us2_profile_editors_weight_saved = /** @type {(inputs: Profile_Editors_Weight_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Weight logged: ${i?.valueText}`)
};

const pt_br2_profile_editors_weight_saved = /** @type {(inputs: Profile_Editors_Weight_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Peso registrado: ${i?.valueText}`)
};

const es_419_profile_editors_weight_saved = /** @type {(inputs: Profile_Editors_Weight_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Peso registrado: ${i?.valueText}`)
};

const pt_pt2_profile_editors_weight_saved = /** @type {(inputs: Profile_Editors_Weight_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Peso registado: ${i?.valueText}`)
};

const fr_fr2_profile_editors_weight_saved = /** @type {(inputs: Profile_Editors_Weight_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Poids enregistré : ${i?.valueText}`)
};

const de_de2_profile_editors_weight_saved = /** @type {(inputs: Profile_Editors_Weight_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gewicht erfasst: ${i?.valueText}`)
};

const it_it2_profile_editors_weight_saved = /** @type {(inputs: Profile_Editors_Weight_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Peso registrato: ${i?.valueText}`)
};

/**
* | output |
* | --- |
* | "Weight logged: {valueText}" |
*
* @param {Profile_Editors_Weight_SavedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_weight_saved = /** @type {((inputs: Profile_Editors_Weight_SavedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Weight_SavedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_weight_saved(inputs)
	if (locale === "es-419") return es_419_profile_editors_weight_saved(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_weight_saved(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_weight_saved(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_weight_saved(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_weight_saved(inputs)
	return en_us2_profile_editors_weight_saved(inputs)
});
export { profile_editors_weight_saved as "profile-editors.weight_saved" }